export default function (app) {
  app.controller('klCustomerCenterBuyOrdersCtrl', [
    '$scope',
    '$state',
    '$window',
    '$http',
    function ($scope, $state, $window, $http) {
      this.isLoading = false;
      this.licenseId = $state.params.params.licenseId || null;
      this.isNewKey = $state.params.params.isNewKey;
      this.availableProductRatePlans = $state.params.params.availableProductRatePlans;
      this.defaultProductRatePlan = $state.params.params.defaultProductRatePlan;
      this.selectedProductRatePlan = this.defaultProductRatePlan;
      this.quantity = 1;
      this.purchaseOrderNumber = undefined;

      const promoStart = Date.parse('2023-02-14T09:00:00.000Z');
      const promoEnd = Date.parse('2023-08-29T01:00:00.000Z');

      this.showPromoMessage = this.isNewKey && Date.now() < promoEnd && Date.now() > promoStart;

      this.increaseQuantity = () => {
        this.quantity++;

        return this.updatePreview();
      };

      this.decreaseQuantity = () => {
        this.quantity--;

        return this.updatePreview();
      };

      this.getSelectedProductRatePlanIndex = () =>
        this.availableProductRatePlans.findIndex((r) => r.id === this.selectedProductRatePlan.id);

      this.selectedProductRatePlanChanged = (ratePlan) => {
        this.selectedProductRatePlan = ratePlan;
        this.subscriptionPreviewPeriods = ratePlan.term === 'year' ? ['Annual'] : ['Month'];

        return this.updatePreview();
      };

      this.updatePreview = () => {
        const payload = { ratePlanId: this.selectedProductRatePlan.id, quantity: this.quantity };
        this.isLoading = true;

        return $http
          .post(`/webshop-api/licenses/${this.licenseId}/subscriptions/preview`, payload)
          .then((res) => {
            if (!res.data.success) {
              throw new Error('Could not fetch preview');
            }

            const invoice = res.data;

            if (!invoice) {
              throw new Error('Could not fetch invoice');
            }

            this.total = { netto: invoice.amountWithoutTax, brutto: invoice.amount };
            this.product = this.total;
            this.quantity = invoice.invoiceItems[0].quantity || this.quantity;
          })
          .catch(this.handleError)
          .finally(() => {
            this.isLoading = false;
          });
      };

      this.abort = () => $state.go('^');

      this.confirm = () => {
        const url = this.isNewKey
          ? `/webshop-api/licenses`
          : `/webshop-api/licenses/${this.licenseId}/subscriptions`;
        const payload = {
          ratePlanId: this.selectedProductRatePlan.id,
          quantity: this.quantity,
          purchaseOrderNumber: this.purchaseOrderNumber,
        };
        this.isLoading = true;

        return $http
          .post(url, payload)
          .then((res) => {
            if (!res.data.success && !res.data.subscription) {
              throw new Error('Could not create license');
            }

            this.successRedirection = true;

            setTimeout(() => $window.location.reload(), 7500);
          })
          .catch(this.handleError);
      };

      this.handleError = (e) => {
        this.errorMessage = e;
        console.error(e);
        this.hasError = true;
        this.isLoading = false;
        $scope.$apply();
      };

      this.selectedProductRatePlanChanged(this.selectedProductRatePlan);
    },
  ]);
}
